export const CURRENCY_SYMBOLS = {
	'USD': '$',
	'GBP': '£',
	'EUR': '€',
	'HUF': 'FT'
};

export const CURRENCY = {
	USD: 'USD',
	EUR: 'EUR'
};
